<template>
  <top-nav />
  <div class="max-w-4xl px-4 pb-10 mx-auto sm:px-6 lg:px-8">
    <div class="space-y-10 sm:py-6">
      <component :is="UserSubscriptionOverview" />
    </div>
  </div>
</template>

<script>
import TopNav from "../components/nav/TopNav.vue";
import { defineAsyncComponent } from "vue";
export default {
  components: {
    TopNav,
  },
  setup() {
    const UserSubscriptionOverview = defineAsyncComponent(() => import("../components/UserSubscriptionOverview.vue"));

    return {
      UserSubscriptionOverview,
    };
  },
};
</script>
